export const getIntegerOrDefault = (value?: unknown, defaultValue = NaN): number => {
  const valueNumber = Number(value);
  if (Number.isNaN(valueNumber)) {
    return defaultValue;
  }
  if (Number.isInteger(valueNumber)) {
    return valueNumber;
  }
  return defaultValue;
};

export default getIntegerOrDefault;

export const getIntegerOrUndefined = (value?: unknown, defaultValue = NaN) => {
  const iord = getIntegerOrDefault(value, defaultValue);
  return (iord === defaultValue || (Number.isNaN(iord) && Number.isNaN(defaultValue)))
    ? undefined
    : iord;
};

/**
 * Return array int not empty or undefined
 */
export const getArrayIntegerFromString = (values: unknown) => {
  if (!values || typeof values !== 'string') {
    return undefined;
  }
  const strings = values.split(',');
  const items: number[] = [];
  strings.forEach((value) => {
    const integer = Number.parseInt(value, 10);
    if (!Number.isNaN(integer)) {
      items.push(integer);
    }
  });

  return items.length > 0 ? items : undefined;
};
